import React from "react";
import OpticksLogo from "@/components/ui/OpticksLogos/OpticksLogo";
import "./OpticksBackground.css";

interface Props {
  children: React.ReactNode;
}

const OpticksBackground = (props: Props) => {
  const { children } = props;
  const contentBoxes = React.Children.map(children, (child) => (
    <div className="content-box">{child}</div>
  ));

  return (
    <div className="opticks-background">
      <OpticksLogo className="opticks-logo-white" height={56} />
      <div className="content-box-wrapper">{contentBoxes}</div>
    </div>
  );
};

export default OpticksBackground;
